<footer class="te-footer te-row-full te-hidden-sm" style="justify-content: space-around;">
    <ul class="te-col-start" style="width: auto;">
        <li style="color: white;"><h4 style="margin: 3px 0 10px 0; color: white;">{{'TEQuickLinks' | translate}}</h4></li>
        <li><a href="http://www.te.com" target="_blank">{{'TECom' | translate}}</a></li>
        <li><a href="https://te360.sharepoint.com/sites/myTE" target="_blank">{{'myTE' | translate}}</a></li>
        <li><a href="https://te360.sharepoint.com/sites/TEIS" target="_blank">{{'TEIS' | translate}}</a></li>
    </ul>
    <ul class="te-col-start" style="width: auto;">
        <li><h4 style="margin: 3px 0 10px 0; color: white;">{{'HomePageTxt3' | translate}}</h4></li>
        <li><a href="https://teconnectivity.service-now.com/sp" target="_blank">{{'HelpDeskText1' | translate}}</a></li>
        <li><a href="../Login/SDContacts" target="_blank" style="cursor:pointer;">{{'HelpDeskText3' | translate}}</a></li>
    </ul>  
    <ul class="te-col-start" style="width: auto;">
        <li></li>
    </ul>
</footer>

<nav class="te-navbar-mobile te-hidden-mob">
    <div class="te-mobile-bottom-bar">
        <a href="#" target="_blank" class="footer-link">
            <i class="fa fa-cog"></i> <span class='footer-text'></span>
        </a>
        <!--href="assets/Regional Service Desk Numbers.pdf"-->
        <a (click)="getSDContacts()"  style="cursor:pointer;" target="_blank" class="footer-link te-row-end">
            <i class="fa fa-sign-out"></i> <span class='footer-text'>{{'HelpDeskText3' | translate}}</span>
        </a>

    </div>
</nav>